import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getDescryptedMedia } from 'srcReact/helpers/utils'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import IconButton from '../IconButton'

const Avatar = (props) => {
  const {
    userId,
    firstname,
    lastname,
    commonInterestsCount,
    profilePicture,
    //below properties are related to select member to send invite(refere group invite/mixr invite pages)
    selectMode,
    selectIcon,
    selectAction,
    unselectAction,
    isSelected,
    forceUnselect,
    deleteMode,
    isAlreadyInvited = false,
    //below props are flag if information needs to be displayed or not
    showRole,
    showCommonInterests,
    showUserName,
    role, //role(s) of user
    currentSearch, //to highlight searched text in username text
    onClickAction,
    lastMemberRef, //for infinite scrolling purpose
    //below props are related to appearance of various content
    imgWrapperSize, //tiny, small, medium, fluid
    customImgWrapperSize,
    borderRadiusInPerc = 50,
    containerCSS,
    customImageCSS,
    userNameCSS,
    roleContainerCSS,
    showImageAsDecorative,
    //image decryption
    mimeType,
    originalTag,
    isOriginal,
    //border orange
    hasOrangeBorder = false,
    user = null,
    width,
    height,
    decryptedProfilePicture = null,
    goingType = '',
    userStatus,
    ariaLabel,
    focusable = true,
    renderBadge = null,
    ariaHidden = false,
    withExpertiseGroup = 0
  } = props

  const { t } = useTranslation()
  const [selected, setSelected] = useState(true)
  const [alreadyInvited, setAlreadyInvited] = useState(false)
  const [completeName, setCompleteName] = useState(`${firstname} ${lastname}`)
  const [completeNameHTML, setCompleteNameHTML] = useState(`${firstname} ${lastname}`)
  const [decryptedImage, setDecryptedImage] = useState('')
  const [imageProcessed, setImageProcessed] = useState(false)

  const {
    login: { user: loggedInUser }
  } = useSelector((state) => state)

  const toggleSelected = () => {
    if (selectAction && !selected) {
      selectAction(user)
    }
    if (unselectAction && selected) {
      unselectAction(user)
    }
    setSelected(!selected)
  }

  const handleClick = (event, userId) => {
    if (selectMode) {
      toggleSelected(userId)
    }
    if (onClickAction) {
      event.stopPropagation()
      if (userStatus !== 'deleted') {
        onClickAction(event)
      }
    }
  }

  const handleDelete = (event) => {
    event.stopPropagation()
    const { deleteAction } = props
    deleteAction(user)
  }
  let style = {
    borderRadius: `${borderRadiusInPerc}%`
  }

  useEffect(() => {
    if (isSelected !== 'undefined') {
      setSelected(isSelected)
    }
  }, [isSelected])
  // static getDerivedStateFromProps(nextProps, prevState) {
  //   if (typeof nextProps.isSelected !== 'undefined' && nextProps.isSelected !== prevState.selected) {
  //     return { selected: nextProps.isSelected }
  //   }
  //   return null
  // }
  useEffect(() => {
    setAlreadyInvited(isAlreadyInvited)

    if (currentSearch !== '') {
      const regexSearchedKey = new RegExp(currentSearch, 'gi')
      setCompleteNameHTML(completeName.replace(regexSearchedKey, '<strong role="presentation">$&</strong>'))
    }
  }, [])

  useEffect(() => {
    if (decryptedProfilePicture) {
      setDecryptedImage(decryptedProfilePicture)
      setImageProcessed(true)
    } else if (profilePicture) {
      getDescryptedMedia(profilePicture, isOriginal, originalTag, mimeType, userId, true).then((data) => {
        if (userId) {
          setDecryptedImage(data.img)
        } else {
          setDecryptedImage(data)
        }
        setImageProcessed(true)
      })
    }
  }, [profilePicture])

  useEffect(() => {
    if (forceUnselect && selected && user) {
      toggleSelected(user)
    }
  }, [selected])
  // let common_interests = 0
  // if (showCommonInterests) {
  //   if (user.info.matched_interests_quantity) {
  //     common_interests = user.info.matched_interests_quantity
  //   } else if (user.common_interests) {
  //     common_interests = user.common_interests.length
  //   }
  // }

  return (
    <div ref={lastMemberRef} className={containerCSS || ''}>
      <button
        tabIndex={focusable ? 0 : -1}
        aria-label={ariaLabel}
        className={`${styles.outerWrapper} ${!focusable && styles.outerWrapperNonFocusable}`}
        onClick={(e) => handleClick(e, userId)}
        {...(ariaHidden ? { ['aria-hidden']: ariaHidden, tabIndex: -1 } : {})}>
        <div className={`${styles.imgWrapper}`}>
          {deleteMode && (
            <IconButton
              iconName='close24'
              className={styles.btnDelete}
              iconCSS={styles.deleteMode}
              onClick={(e) => handleDelete(e)}
            />
          )}
          {selectMode && selected && (
            <div className={styles.selectMode}>
              {selectIcon && selectIcon == 'check' && (
                <Icon name='check24' size='small' styleModifier={styles.overlayIcon} />
              )}
              {selectIcon && selectIcon == 'paperplane' && (
                <Icon name='send' size='large' styleModifier={styles.overlayIcon} />
              )}
            </div>
          )}
          {alreadyInvited && !selected && (
            <div className={styles.alreadyInvitedSelect}>
              <Icon name='send' size='large' styleModifier={styles.overlayIcon} />
            </div>
          )}
          {/* This expertise badge will be replaced by top-contributor badge 1206988292232643*/}
          {/* {withExpertiseGroup === 1 && <Icon name='star-solid' styleModifier={styles.expertiseIcon} />} */}
          <img
            onError={(e) => (e.target.src = `${config.assetUrl}/images/default_avatar.jpeg`)}
            width={width}
            height={height}
            role={showImageAsDecorative && 'presentation'}
            title={`${firstname} ${lastname}`}
            alt={showImageAsDecorative ? '' : `${firstname} ${lastname}`}
            style={style}
            className={`${styles.image} ${customImageCSS} ${onClickAction && styles.pointerCursor} ${
              hasOrangeBorder && styles.borderOrange
            } ${customImgWrapperSize || styles[imgWrapperSize]}`}
            // ${withExpertiseGroup === 1 && styles.expertiseGroup}
            src={
              userStatus === 'deleted' ? (
                `${config.assetUrl}/images/default_avatar.jpeg`
              ) : isOriginal === 0 ? (
                imageProcessed ? (
                  decryptedImage
                ) : (
                  <Icon
                    name='contact'
                    styleModifier={`${styles.imageSVG} ${customImageCSS} ${hasOrangeBorder && styles.borderOrange} ${
                      styles[imgWrapperSize]
                    }`}
                  />
                )
              ) : (
                profilePicture
              )
            }
          />
          {renderBadge && renderBadge()}
        </div>
        {showUserName ? (
          currentSearch ? (
            <span
              className={`${styles.userNameText} ${userNameCSS}`}
              dangerouslySetInnerHTML={{ __html: completeNameHTML }}
            />
          ) : (
            <span className={`${styles.userNameText} ${userNameCSS}`}>
              {lastname ? `${firstname} ${lastname}` : firstname}
            </span>
          )
        ) : null}
        {showRole && role && (
          <div className={`${styles.roleContainer} ${roleContainerCSS}`}>
            <span className={styles.role}>{role}</span>
            {goingType === 'in_person' && <Icon name='inpersonmixr' styleModifier={styles.inpersonIcon} />}
            {goingType === 'virtual' && <Icon name='virtualmixr-icon' styleModifier={styles.virtualIcon} />}
          </div>
        )}
        {showCommonInterests && loggedInUser?.id !== userId && (
          <span className={commonInterestsCount && commonInterestsCount > 0 ? styles.interests : styles.noInterests}>
            {t('components.avatar.shared_interest', {
              count: commonInterestsCount || 0
            })}
          </span>
        )}
      </button>
    </div>
  )
}

export default Avatar
